import {
    FETCH_REWARDS,
    FETCH_REWARDDETAILS,
    FETCH_REWARDTARGETS
} from '../actions/reward';


export const initialState = {
    isFetching: true,
    data: null
};

export const rewards = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_REWARDS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_REWARDS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const rewardDetails = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_REWARDDETAILS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_REWARDDETAILS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const rewardTargets = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_REWARDTARGETS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_REWARDTARGETS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/reward.js